const RestaurantReviewTemplate = ({ name, date, review }) => {
  return `
  <div class="review review-text">
      <div class="review__name-date">
        <div class="name">${name}</div>
        <div class="date">${date}</div>
      </div>
      <div class="text">
      "${review}"
      </div>
    </div>
  `
}

export default RestaurantReviewTemplate
